import React, { useState } from "react";
import { TextField, Button, Box, Typography, CircularProgress, Alert } from "@mui/material";
// import nutsByPowiat from './nuts_by_powiat.json';


const PostalCodeForm = ({ filterLocation, addError }) => {
    const [postalCode, setPostalCode] = useState("");
    const [voivodeship, setVoivodeship] = useState("");
    const [county, setCounty] = useState("");
    const [municipality, setMunicipality] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handlePostalCodeChange = (e) => setPostalCode(e.target.value);

    const fetchAdminData = async () => {
        if (!postalCode.match(/^\d{2}-\d{3}$/)) {
            setError("Kod pocztowy musi być w formacie XX-XXX");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const response = await fetch(`https://kodpocztowy.intami.pl/api/${postalCode}`);

            if (!response.ok) {
                throw new Error("Nie znaleziono danych dla tego kodu pocztowego");
            }

            const data = await response.json();

            if (!Array.isArray(data) || data.length === 0) {
                throw new Error("Brak danych dla tego kodu pocztowego");
            }

            const uniqueVoivodeships = [...new Set(data.map((item) => item.wojewodztwo).filter(Boolean))];
            const uniqueCounties = [...new Set(data.map((item) => item.powiat).filter(Boolean))];
            const uniqueMunicipalities = [...new Set(data.map((item) => item.gmina).filter(Boolean))];

            const voivodeshipValue = uniqueVoivodeships.join(", ");
            const countyValue = uniqueCounties.join(", ");
            const municipalityValue = uniqueMunicipalities.join(", ");

            setVoivodeship(voivodeshipValue);
            setCounty(countyValue);
            setMunicipality(municipalityValue);

            filterLocation({
                voivodeship: voivodeshipValue,
                county: countyValue,
                municipality: municipalityValue,
            });

        } catch (err) {
            setError(err.message);
            setVoivodeship("");
            setCounty("");
            setMunicipality("");
            filterLocation({ voivodeship: "", county: "", municipality: "" });
        } finally {
            setLoading(false);
        }
    };


    // function slugifyPowiat(name) {
    //     return name
    //         .toLowerCase()
    //         .normalize("NFD")
    //         .replace(/[\u0300-\u036f]/g, "")
    //         .replace(/\s+/g, "-");
    // }

    // const powiatSlug = slugifyPowiat("Jelenia Góra");
    // const region = nutsByPowiat[powiatSlug];

    return (
        <>
            {/* <Typography variant="h7" gutterBottom>
                Wpisz kod pocztowy
            </Typography> */}

            <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2 }}>
                <TextField
                    label="Kod pocztowy"
                    variant="outlined"
                    value={postalCode}
                    onChange={handlePostalCodeChange}
                    placeholder="XX-XXX"
                    fullWidth
                />
                <Button variant="contained" onClick={fetchAdminData} disabled={loading}>
                    Szukaj
                </Button>
            </Box>

            {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                    <CircularProgress size={24} />
                </Box>
            )}

            {error && (
                <Typography color="error" mb={2}>
                    {error}
                </Typography>
            )}

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <TextField
                    label="Województwo"
                    variant="outlined"
                    value={voivodeship}
                    InputProps={{ readOnly: true }}
                    disabled
                />
                <TextField
                    label="Powiat"
                    variant="outlined"
                    value={county}
                    InputProps={{ readOnly: true }}
                    disabled
                />
                <TextField
                    label="Gmina"
                    variant="outlined"
                    value={municipality}
                    InputProps={{ readOnly: true }}
                    disabled
                />
                {addError && (
                    <Alert severity="error" mt={2} mb={2}>
                        {addError}
                    </Alert>
                )}
            </Box>

        </>
    );
};

export default PostalCodeForm;


// import React, { useState } from "react";
// import { TextField, Button, Box, Typography, CircularProgress } from "@mui/material";

// const PostalCodeForm = ({ filterLocation }) => {
//     const [postalCode, setPostalCode] = useState("");
//     const [province, setProvince] = useState("");
//     const [county, setCounty] = useState("");
//     const [commune, setCommune] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState("");

//     const handlePostalCodeChange = (e) => {
//         setPostalCode(e.target.value);
//     };

//     const fetchAdminData = async () => {
//         if (!postalCode.match(/^\d{2}-\d{3}$/)) {
//             setError("Kod pocztowy musi być w formacie XX-XXX");
//             return;
//         }

//         setLoading(true);
//         setError("");

//         try {
//             const response = await fetch(
//                 `https://kodpocztowy.intami.pl/api/${postalCode}`
//             );

//             if (!response.ok) {
//                 throw new Error("Nie znaleziono danych dla tego kodu pocztowego");
//             }

//             const data = await response.json();

//             if (!Array.isArray(data) || data.length === 0) {
//                 throw new Error("Brak danych dla tego kodu pocztowego");
//             }

//             const uniqueProvinces = [...new Set(data.map((item) => item.wojewodztwo).filter(Boolean))];
//             const uniqueCounties = [...new Set(data.map((item) => item.powiat).filter(Boolean))];
//             const uniqueCommunes = [...new Set(data.map((item) => item.gmina).filter(Boolean))];

//             setProvince(uniqueProvinces.join(", "));
//             setCounty(uniqueCounties.join(", "));
//             setCommune(uniqueCommunes.join(", "));
//             filterLocation({ province: uniqueProvinces.join(", "), county: uniqueCounties.join(", "), commune: uniqueCommunes.join(", ") });

//         } catch (err) {
//             setError(err.message);
//             setProvince("");
//             setCounty("");
//             setCommune("");
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <>
//             {/* <Box
//             sx={{
//                 maxWidth: 400,
//                 margin: "40px auto",
//                 padding: 3,
//                 border: "1px solid #ccc",
//                 borderRadius: 2,
//                 boxShadow: 2,
//             }}
//         > */}
//             <Typography variant="h5" gutterBottom>
//                 Wpisz kod pocztowy
//             </Typography>

//             <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2 }}>
//                 <TextField
//                     label="Kod pocztowy"
//                     variant="outlined"
//                     value={postalCode}
//                     onChange={handlePostalCodeChange}
//                     placeholder="XX-XXX"
//                     fullWidth
//                 />
//                 <Button variant="contained" onClick={fetchAdminData} disabled={loading}>
//                     Szukaj
//                 </Button>
//             </Box>

//             {loading && (
//                 <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
//                     <CircularProgress size={24} />
//                 </Box>
//             )}

//             {error && (
//                 <Typography color="error" mb={2}>
//                     {error}
//                 </Typography>
//             )}

//             <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//                 <TextField
//                     label="Województwo"
//                     variant="outlined"
//                     value={province}
//                     InputProps={{ readOnly: true }}
//                 />
//                 <TextField
//                     label="Powiat"
//                     variant="outlined"
//                     value={county}
//                     InputProps={{ readOnly: true }}
//                 />
//                 <TextField
//                     label="Gmina"
//                     variant="outlined"
//                     value={commune}
//                     InputProps={{ readOnly: true }}
//                 />
//             </Box>
//             {/* </Box> */}
//         </>
//     );
// };

// export default PostalCodeForm;